import type { BadgeTone } from "components/ui/StatusBadge/StatusBadge";

/**
 * Backend DeliveryStatus enum と整合した status → ラベル / tone マッピング.
 * 配信一覧 (フラット表示) とシリーズ別表示の両方で再利用する.
 */
export const DELIVERY_STATUS_BADGE: Record<
  string,
  { label: string; tone: BadgeTone }
> = {
  sent: { label: "送信完了", tone: "soft-success" },
  // biome-ignore lint/style/useNamingConvention: matches backend DeliveryStatus enum value
  partially_sent: { label: "一部失敗", tone: "soft-warning" },
  failed: { label: "失敗", tone: "critical-error" },
  sending: { label: "送信中", tone: "soft-info" },
  scheduled: { label: "予約中", tone: "soft-info" },
  draft: { label: "下書き", tone: "soft-neutral" },
  cancelled: { label: "キャンセル", tone: "soft-neutral" },
};
